<!-- Institute of Design and Innovation (email idi@unm.edu). -->

<!-- Page layout -->
<template>
  <router-view />
</template>

<script>
export default {
  name: 'Layout'
}
</script>
